import { inject, Injectable } from '@angular/core';
import { SelectedApexMech, StateTypes, ViewStateType } from '@ortho-next/nextray-core';
import { AnatomicalSideEnum, BoneTypeEnum } from '../core';
import { BaseHelpService } from './base-help.service';
import { CanvasService } from './canvas.service';


/**
* This service handles help modal.
*/
@Injectable({ providedIn: 'root' })
export class HelpService extends BaseHelpService {

	private readonly canvasSrv = inject(CanvasService);


	override get fileKey(): string {
		switch (this.canvasSrv.stateType) {
			case StateTypes.new: return `NEW`;
			case StateTypes.calibrated: return `CALIBRATED`;
			case StateTypes.deformityAnalysis: return `DEFORMITY_${this.boneType}_${this.side}_${this.activeView}`;
			case StateTypes.EOC: return `CORRECTION_${this.boneType}_${this.side}_${this.activeView}`;
			case StateTypes.templating: return `JPS_${this.osteotomyBone}_${this.side}_${this.activeView}_${this.osteotomySite}`;
			default: return ``;
		}
	}

	private get boneType(): string {
		if (!this.canvasSrv.currentCase) return '';
		switch (this.canvasSrv.currentCase.boneType) {
			case BoneTypeEnum.LongLeg: return 'FULLLEG';
			case BoneTypeEnum.Femur: return 'FEMUR';
			case BoneTypeEnum.Tibia: return 'TIBIA';
			default: return '';
		}
	}

	private get side(): string {
		if (!this.canvasSrv.currentCase) return '';
		switch (this.canvasSrv.currentCase.side) {
			case AnatomicalSideEnum.Left: return 'LEFT';
			case AnatomicalSideEnum.Right: return 'RIGHT';
			default: return '';
		}
	}

	private get activeView(): string {
		switch (this.canvasSrv.activeViewState) {
			case ViewStateType.AP: return 'AP';
			case ViewStateType.LT: return 'LAT';
			case ViewStateType.multiple: return 'MUL';
			default: return '';
		}
	}

	private get osteotomyBone(): string {
		switch (this.canvasSrv.selectedApex) {
			case SelectedApexMech.femurProximal:
			case SelectedApexMech.femurDistal: return 'FEMUR';
			case SelectedApexMech.tibiaProximal:
			case SelectedApexMech.tibiaDistal: return 'TIBIA';
			default: return '';
		}
	}

	private get osteotomySite(): string {
		switch (this.canvasSrv.selectedApex) {
			case SelectedApexMech.femurProximal:
			case SelectedApexMech.tibiaProximal: return 'PROXIMAL';
			case SelectedApexMech.femurDistal:
			case SelectedApexMech.tibiaDistal: return 'DISTAL';
			default: return '';
		}
	}

}
